import React from "react";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import UploadModalActionManager from "../../../../action_managers/upload_modal";
import { If } from "react-extras";
import FileUploadV2 from "../../../forms/file_upload/file_upload_v2";
import MediaPlayer from "../../../lib/media_player";
import { ModalContentWrapper } from "./accept_advertisement_modal_helpers";
import { respondToCampaignOffer } from "../../../../actions/campaigns";
import {
  CampaignItemStateAwaitingAudio,
  PromoCodeTypeNone,
  PromoCodeTypePodcasterUnique,
  PromoCodeTypeStandard,
} from "../../../../constants/campaigns";
import { handleRespPromise } from "../../../../lib/http";
import { quillIsEmpty } from "../../../../lib/forms";

export const ScriptAndUploadContent = props => {
  const { campaign, setMediaFileUUID, mediaFileUUID, includeUpload } = props;
  const script = get(campaign, "script", "");
  const scriptTips = get(campaign, "scriptTip", "");
  const user = useSelector(state => state.user.user);
  const dispatch = useDispatch();
  const mediaFiles = useSelector(state => state.mediaFiles);
  const isLoading = useSelector(state => state.mediaFileUpload.isLoading);

  const uploadFile = files => {
    const file = files[0];
    return dispatch(
      new UploadModalActionManager({
        file,
        fileName: file.name,
        authToken: user.authToken,
      }).run()
    ).then(resp => {
      if (resp.status === 200) {
        const json = get(resp, "json");
        const mediaFile = json[0];
        setMediaFileUUID(mediaFile.uuid);
      }
    });
  };

  const getSubHeader = () => {
    if (!props.includeUpload) {
      return (
        <span>
          Review the script and select if you’d like to accept this campaign. Once you accept,
          you’ll have time to receive the product sample before uploading your audio. Audio will
          need to be uploaded <strong>2 days</strong> before the start of the campaign.
        </span>
      );
    }

    if (props.campaignItem.state === CampaignItemStateAwaitingAudio) {
      return (
        <span>
          Review the details of the ad read below then record and upload your Host-Read audio for
          this promotion. Once uploaded, click <strong>Submit</strong>. This ad will automatically
          run on the available audio blocks on your show’s episodes.
        </span>
      );
    }

    return (
      <span>
        To accept this campaign, review the details of the ad read below then record and upload your
        audio for this promotion. Once uploaded, click <strong>Accept & Run</strong> to submit your
        Host-Read audio. This ad will automatically run on the available audio blocks on your show’s
        episodes.
      </span>
    );
  };

  const getPromoCode = () => {
    switch (campaign.promoCodeType) {
      case PromoCodeTypePodcasterUnique:
        return props.campaignItem.promoCode || props.show.promoCode;
      case PromoCodeTypeStandard:
        return "A standard promotion code is provided in the talking points or script";
      case PromoCodeTypeNone:
      default:
        return "No Promotion Code";
    }
  };
  return (
    <>
      <div className="margin-bottom--small">{getSubHeader()}</div>
      <div className="margin-top--large">
        <div className="redcircle-form-label">Script or talking points</div>
        <div className={"fake-text-box"} dangerouslySetInnerHTML={{ __html: script }} />
        <If condition={!!scriptTips && !quillIsEmpty(scriptTips)}>
          <>
            <div className="margin-top--large redcircle-form-label">Requirements from Brand</div>
            <div className={"fake-text-box"} dangerouslySetInnerHTML={{ __html: scriptTips }} />
          </>
        </If>
      </div>
      <div className={"m-ts"}>
        <div className="redcircle-form-label">Campaign Promotion Code</div>
        {getPromoCode()}
      </div>
      {includeUpload && (
        <>
          <div>
            <div className="margin-top--large redcircle-form-label">UPLOAD MP3</div>
            <FileUploadV2
              onChange={uploadFile}
              isLoading={isLoading}
              mediaFileUUID={mediaFileUUID}
              mediaFiles={mediaFiles}
            />
          </div>

          <div>
            <MediaPlayer mediaFileUUID={mediaFileUUID} />
          </div>
        </>
      )}
    </>
  );
};
const isAwaitingAudio = ({ campaignItem }) => {
  return campaignItem.state === CampaignItemStateAwaitingAudio;
};
const getTitle = (props, isUploadModal) => {
  if (isAwaitingAudio(props)) {
    return "Upload & Submit Advertisement";
  }
  return isUploadModal ? "Accept & Upload Advertisement" : "Script Review";
};

const getSubmitText = (props, isUploadModal) => {
  if (isAwaitingAudio(props)) {
    return "Submit";
  }
  return isUploadModal ? "Accept & Run" : "Accept";
};

export const acceptAndUploadConfig = props => {
  const { campaign, campaignItem, dispatch, mediaFileUUID } = props;
  const isHostRead = campaign?.style === "hostRead";
  const isUploadModal = props.includeUpload && isHostRead;

  return {
    title: getTitle(props, isUploadModal),
    submitText: getSubmitText(props, isUploadModal),
    onSubmit: () => {
      const campaignItemUUID = campaignItem?.uuid;
      const respondToOfferArgs = [campaignItemUUID, "accepted"];
      if (isHostRead) {
        respondToOfferArgs.push(mediaFileUUID);
      }

      return dispatch(respondToCampaignOffer(...respondToOfferArgs)).then(handleRespPromise);
    },
    disabled: isUploadModal && !mediaFileUUID,
    Content: (
      <ModalContentWrapper>
        <ScriptAndUploadContent {...props} />
      </ModalContentWrapper>
    ),
  };
};
